import { DemoPicker } from '@/components/shared/DemoPicker';
import { useAppLock } from '@/components/AppLock';
import { LockMenu } from '@/components/AppLock/LockMenu';
import { useAppStore } from '@/store/store';

interface HeaderProps {
  onSettingsClick: () => void;
  onDemoLoad: () => void;
  onFeedbackClick: () => void;
}

export function Header({ onSettingsClick, onDemoLoad, onFeedbackClick }: HeaderProps) {
  const { lock, isEnabled, enableEncryption } = useAppLock();
  const showDemoOption = useAppStore((s) => s.preferences.showDemoOption);

  return (
    <header
      style={{
        height: 'var(--header-height)',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        padding: '0 var(--space-4)',
        borderBottom: '1px solid var(--color-border)',
        background: 'var(--color-bg-primary)',
        position: 'sticky',
        top: 0,
        zIndex: 50,
      }}
    >
      <h1 style={{ fontSize: 'var(--font-size-lg)', fontWeight: 'var(--font-weight-extrabold)', letterSpacing: '-0.02em', display: 'inline-flex', alignItems: 'baseline', gap: 'var(--space-2)' }}>
        <span aria-hidden="true" style={{ display: 'inline-block', width: '4px', height: '1.1em', background: 'var(--color-accent)', borderRadius: '2px', alignSelf: 'center' }} />
        Freight <span style={{ color: 'var(--color-accent)' }}>CBM</span>
      </h1>
      <div style={{ display: 'flex', alignItems: 'center', gap: 'var(--space-2)', flexWrap: 'wrap' }}>
        {showDemoOption && <DemoPicker onLoad={onDemoLoad} />}
        {isEnabled && lock ? (
          <LockMenu lock={lock} />
        ) : !isEnabled ? (
          <button
            type="button"
            className="btn btn-primary btn-sm"
            onClick={enableEncryption}
            title="Enable password protection"
            aria-label="Enable app lock"
          >
            Lock
          </button>
        ) : null}
        <button
          type="button"
          className="btn btn-sm"
          onClick={onFeedbackClick}
          aria-label="Send feedback"
          title="Feedback"
        >
          Feedback
        </button>
        <button
          type="button"
          className="btn btn-sm"
          onClick={onSettingsClick}
          aria-label="Settings"
          title="Settings"
        >
          Settings
        </button>
      </div>
    </header>
  );
}
